import { Button, Checkbox, Grid, Select, Table, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconArrowRightBar } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebounce } from '../../Hooks/useDebounce';
import { moveAllocation } from '../../api/allocation';
import { getPono } from '../../api/poList';
import { getAllocationList } from '../../api/styleList';
import NavBar from '../../components/NavBar/NavBar';
import { PoNoWithStatus } from '../../interface/AllocationInvoice';
import '../Global.css';
import classes from './ModifyAllocation.module.css';


const ChangeAllocation: React.FC = () => {
    const [poNoList, setPoNoList] = useState<any[]>([]);
    const [poNoList2, setPoNoList2] = useState<any[]>([]);
    const [styleList, setStyleList] = useState<any[]>([]);
    const [styleList2, setStyleList2] = useState<any[]>([]);
    const [allocationData, setAllocationData] = useState<any[]>([]);
    const [allocationData2, setAllocationData2] = useState<any[]>([]);
    const [po, setPo] = useState<{ poNo: string, poId: string }>({ poNo: '', poId: '' });
    const [po2, setPo2] = useState<{ poNo: string, poId: string }>({ poNo: '', poId: '' });
    const poSearch = useDebounce(po.poNo, 700);
    const poSearch2 = useDebounce(po2.poNo, 700);
    const token = useSelector((state: any) => state.user.sessionId);
    const [transferList, setTransferList] = useState<any[]>([]);
    const isMobile = useMediaQuery("(min-width: 0) and (max-width: 550px)") || false;
    const getPo = async () => {
        const poList = await getPono(token, po?.poNo);
        if (poList) {
            setPoNoList(poList?.data?.map((item: PoNoWithStatus) => {
                return {
                    label: item.poNo,    // Use `item.poNo` for the label
                    value: item.poId!.toString(),  // Convert `poId` to string for the value
                };
            }))
        }
    }

    const getPo2 = async () => {
        const poList2 = await getPono(token, po2?.poNo);
        if (poList2) {
            setPoNoList2(poList2?.data?.map((item: PoNoWithStatus) => {
                return {
                    label: item.poNo,    // Use `item.poNo` for the label
                    value: item.poId!.toString(),  // Convert `poId` to string for the value
                };
            }))
        }
    }

    useEffect(() => {
        getPo();
    }, [poSearch]);
    useEffect(() => {
        getPo2();
    }, [poSearch2]);

    const handlePoNoChange = async (value: string | null) => {
        if (value) {
            setPo({ poId: value?.toString() || '', poNo: poNoList.find((item: any) => item.value === value).label });
            const allocations = await getAllocationList(token, parseInt(value));
            setAllocationData(allocations);
            if (allocations) {
                setStyleList(allocations.map((item: any) => {
                    return {
                        label: item.style_no,
                        value: item.style_id.toString()
                    }
                }))
            }
        }
    }
    const handlePoNo2Change = async (value: string | null) => {
        if (value) {
            setPo2({ poId: value?.toString() || '', poNo: poNoList2.find((item: any) => item.value === value).label });
            const allocations2 = await getAllocationList(token, parseInt(value));
            setAllocationData2(allocations2);
            if (allocations2) {
                setStyleList2(allocations2.map((item: any) => {
                    return {
                        label: item.style_no,
                        value: item.style_id.toString()
                    }
                }))
            }
        }
    }

    const handleCheck = (value: number) => {
        if (transferList.includes(value.toString())) {
            setTransferList(transferList.filter((item) => item !== value));
        } else {
            setTransferList([...transferList, value]);
        }
    }
    const handleMove = async () => {
        if (allocationData?.length === 0 || allocationData2?.length === 0) {
            alert(`Please select po.`);
            return;
        }
        if (transferList?.length === 0) {
            alert(`Please select styles to move.`);
            return;
        }
        let duplicateStyles = false;
        allocationData2.forEach((item: any) => {
            if (transferList.includes(item.style_style_id.toString())) {
                duplicateStyles = true;
                return;
            }
        })
        if (duplicateStyles) {
            alert(`Selected styles are already present in the Po.`);
            return;
        }
        const confirm = window.confirm(`Are you sure you want to move ${transferList.length} styles?`);
        if (!confirm) return;
        try {
            const allocations = allocationData.filter((item: any) => transferList.includes(item.style_style_id.toString())).map((item: any) => item.allocation_id);
            const { data, message } = await moveAllocation(token, allocations, transferList, allocationData2[0]?.po_no);
            if (data) {
                setStyleList(styleList.filter((item: any) => !transferList.includes(item.value)));
                setStyleList2([...styleList2, ...styleList.filter((item: any) => transferList.includes(item.value))]);
                // clear the transfer list
                setTransferList([]);
                alert('Style moved successfully.');
            }
            if (message) alert(message);
            return;
        } catch (error) {
            console.log('Error deleting allocation:', error);
        }
    }

    return (
        <div>
            <NavBar />
            <div className={'main'}>
                <h2 className={'title'}>Change Allocation</h2>
                <div style={{ width: '100%', marginBottom: '50px' }}>
                    <Grid >
                    </Grid>
                    {allocationData && (<div>
                        <Grid style={{ padding: '20px' }}>
                            <Grid.Col span={isMobile ? 12 : 5}>
                                <div>
                                    <div >
                                        <Table withTableBorder withColumnBorders stickyHeader >
                                            <Table.Thead >
                                                <Table.Tr key={`table1header`}>
                                                    <Table.Th key={'poNo'} style={{ textAlign: 'center' }} colSpan={2}>
                                                        <Select
                                                            data={poNoList}
                                                            label='Po No'
                                                            placeholder="Select Po No"
                                                            style={{ flexGrow: 1 }}
                                                            className={classes.selectDiv}
                                                            searchable
                                                            clearable
                                                            onChange={handlePoNoChange}
                                                            onSearchChange={(e) => setPo({ ...po, poNo: e.toUpperCase() })}
                                                            onClear={() => {
                                                                setPo({ poId: '', poNo: '' })
                                                                // setAllocation(undefined);
                                                            }}
                                                        />
                                                    </Table.Th>
                                                </Table.Tr>
                                            </Table.Thead>
                                            <Table.Tbody >
                                                <Table.Tr className={classes.tableHead}>
                                                    <Table.Th style={{ width: '20px' }}>No</Table.Th>
                                                    <Table.Th>Styles</Table.Th>
                                                </Table.Tr>
                                                {styleList.map((item: any, index: number) => (<Table.Tr key={`styleList-${index}`}>
                                                    <Table.Td >
                                                        <Text style={{ padding: '5px' }}>{index + 1}</Text>
                                                    </Table.Td>
                                                    <Table.Td className={classes.listItem}>
                                                        <Checkbox checked={transferList.includes(item.value.toString())} onChange={() => handleCheck(item.value)} />
                                                        {item.label}
                                                    </Table.Td>
                                                </Table.Tr>))}
                                            </Table.Tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Grid.Col>
                            <Grid.Col span={isMobile ? 12 : 2}>
                                {allocationData && (<Button style={{ marginTop: '30px', width: '100%' }} variant='outline' className={'icon'} onClick={handleMove}><IconArrowRightBar />Move</Button>)}
                            </Grid.Col>
                            <Grid.Col span={isMobile ? 12 : 5}>
                                <div>
                                    <div>
                                        <Table withTableBorder withColumnBorders stickyHeader >
                                            <Table.Thead>
                                                <Table.Tr key={`table2header`}>
                                                    <Table.Th key={'poNo2'} style={{ textAlign: 'center' }} colSpan={2}><Select
                                                        data={poNoList2}
                                                        label='Po No'
                                                        placeholder="Select Po No"
                                                        style={{ flexGrow: 1 }}
                                                        className={classes.selectDiv}
                                                        searchable
                                                        clearable
                                                        onChange={handlePoNo2Change}
                                                        onSearchChange={(e) => setPo2({ ...po, poNo: e.toUpperCase() })}
                                                        onClear={() => {
                                                            setPo2({ poId: '', poNo: '' })
                                                            // setAllocation(undefined);
                                                        }}
                                                    />
                                                    </Table.Th>
                                                </Table.Tr>
                                            </Table.Thead>
                                            <Table.Tbody>
                                                <Table.Tr className={classes.tableHead}>
                                                <Table.Th style={{ width: '20px' }}>No</Table.Th>
                                                    <Table.Th>Styles</Table.Th>
                                                </Table.Tr>
                                                {styleList2.map((item: any, index: number) => (
                                                    <Table.Tr key={`styleList2-${index}`}>
                                                        <Table.Td >
                                                            <Text style={{ padding: '5px' }}>{index + 1}</Text>
                                                        </Table.Td>
                                                        <Table.Td className={classes.listItem}>{item.label}</Table.Td>
                                                    </Table.Tr>))}
                                            </Table.Tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Grid.Col>
                        </Grid></div>)}
                </div>
            </div >
            <div className={'footerDiv'}>
                <Text></Text>
                <Text c={'red'} fw={'bold'}>**Please make sure you have selected the correct PO and styles to move.**</Text>
                <Text></Text>
            </div>
        </div >
    )
}

export default ChangeAllocation;